__webpack_require__.p = "https://accounting.stagingcapital.com/";